// extracted by mini-css-extract-plugin
module.exports = {"imageRounded":"_26Qfc","sectionInfo":"_1Zm9_","sectionDetail":"_2TFCK","postTagItem":"_2E9T4","verticalLinks":"hG7Zl"};